import * as React from 'react';
import dynamic from 'next/dynamic';
import { IconProps } from '@mybet/components/Icons';
const EighteenPlusIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "EighteenPlusIcon"*/ '@mybet/components/Icons/EighteenPlus'
    )
);
const ComodoIcon = dynamic(
  () =>
    import(/* webpackChunkName: "ComodoIcon"*/ '@mybet/components/Icons/Comodo')
);
const GameCareIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "GameCareIcon"*/ '@mybet/components/Icons/GameCare'
    )
);
const MGAIcon = dynamic(
  () => import(/* webpackChunkName: "MGAIcon"*/ '@mybet/components/Icons/MGA')
);
const PCIIcon = dynamic(
  () => import(/* webpackChunkName: "PCIIcon"*/ '@mybet/components/Icons/PCI')
);

enum CertificateIcons {
  '18plus' = '18plus',
  comodo = 'comodo',
  gamecare = 'gamecare',
  mga = 'mga',
  pci = 'pci',
}
export type CertificateIconType = keyof typeof CertificateIcons;
type CertificateIconProps = IconProps & {
  icon: CertificateIconType;
};

const CertificateIcon: React.FC<CertificateIconProps> = (props) => {
  const { icon, ...rest } = props;
  return (
    <>
      {icon === '18plus' && (
        <EighteenPlusIcon {...rest} viewBox="0 0 44 32" width={44} />
      )}
      {icon === 'comodo' && (
        <ComodoIcon {...rest} viewBox="0 0 89 32" width={89} />
      )}
      {icon === 'gamecare' && (
        <GameCareIcon {...rest} viewBox="0 0 43 32" width={43} />
      )}
      {icon === 'mga' && <MGAIcon {...rest} viewBox="0 0 125 32" width={125} />}
      {icon === 'pci' && <PCIIcon {...rest} viewBox="0 0 68 32" width={68} />}
    </>
  );
};

export default CertificateIcon;
